import React, { Component } from 'react';
import AppContentComponent from '../../../templates/content'
import AppCampaignsCreateDialogComponent from '../../../components/campaigns/components/create/modal'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import AppPromotionsFormComponent from './parts/form'
import { api } from "../../../../api/index"

class AppPromotionsCreateComponent extends Component {

	constructor(props) {
		super(props);

		this.createPromotion = this.createPromotion.bind(this);
	}

	createPromotion(event) {
		event.preventDefault();

		return api.promotions.create();
	}

	componentDidMount() {
		api.promotions.resetPromotion();
	}

	render() {
		return (
			<AppContentComponent>
				<h1>Promotie toevoegen</h1>
				<AppPromotionsFormComponent savePromotion={this.createPromotion} savePromotionLabel="Promotie opslaan"/>
				<AppCampaignsCreateDialogComponent />
			</AppContentComponent>
		)
	}
}

const mapStateToProps = ( state ) => {
	return {
		promotion: state.promotion
	}
};

export default connect(mapStateToProps)(AppPromotionsCreateComponent);


// WEBPACK FOOTER //
// ./src/application/components/promotions/components/create.js